import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../common';
import { IDiagnosesGroup, IDiagnosesGroupCreate, IDiagnosesGroupItem, IDiagnosesGroupsListRequest } from './models';

export const diagnosesGroupsApiSlice = createApi({
  reducerPath: 'diagnosesGroups/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'diagnoses-groups/',
  }),
  tagTypes: ['DiagnosesGroups'],
  endpoints: builder => ({
    getDiagnosesGroupById: builder.query<IDiagnosesGroup, number>({
      query: (id: number) => ({
        url: `${id}`,
        method: 'GET',
      }),
      transformResponse: (response: IAxiosResponse<IDiagnosesGroup>) => ({
        ...response.data,
      }),
    }),
    getDiagnosesGroups: builder.query<IDiagnosesGroupItem[], IDiagnosesGroupsListRequest>({
      query: data => ({
        url: 'search',
        method: 'POST',
        data,
      }),
      transformResponse: (response: IAxiosResponse<IDiagnosesGroupItem[]>) => response.data,
      providesTags: ['DiagnosesGroups'],
    }),
    createDiagnosesGroup: builder.mutation<number, IDiagnosesGroupCreate>({
      query: data => ({
        url: 'create',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['DiagnosesGroups'],
    }),
    deleteDiagnosesGroup: builder.mutation<string, number>({
      query: id => ({
        url: `${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DiagnosesGroups'],
    }),
  }),
});
